import { useTranslation } from "react-i18next";

import { Card } from "@/components/Card";
import { Missing } from "@/components/Missing";

import type { ActiveWidget } from "../../hooks/useEventWidgets";

import { AttendingCard } from "./AttendingCard/AttendingCard";
import { DirectionsCard } from "./DirectionsCard/DirectionsCard";
import { DiscussionsCard } from "./DiscussionsCard";
import { EventSummaryCard } from "./EventSummaryCard/EventSummaryCard";
import { NoteCard } from "./NoteCard/NoteCard";
import { PollCard } from "./PollCard/PollCard";

export function EventLayoutCardContent({ widget }: { widget: ActiveWidget }) {
  const { t } = useTranslation();
  switch (widget.widget_type) {
    case "summary":
      return <EventSummaryCard />;
    case "discussion":
      return <DiscussionsCard />;
    case "attending":
      return <AttendingCard />;
    case "directions":
      return <DirectionsCard widget={widget} />;
    case "poll":
      return <PollCard widget={widget} />;
    case "note":
      return <NoteCard widget={widget} />;
    default:
      widget satisfies never;
      return (
        <Card className="opacity-75">
          <Missing>{t("unknown-widget-please-update")}</Missing>
        </Card>
      );
  }
}
